export const TIP_SELECTOR_TEST_ID = {
  root: 'tip-selector',
  customOption: 'tip-selector-custom-option',
  noneOption: 'tip-selector-none-option',
  customTipInput: 'tip-selector-custom-tip-input'
};
